<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-monitor"></i> 输煤设备状态监测
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container">
            <div>
                <div class="handle-headleft">
                    <el-button type="primary" icon="el-icon-printer" @click="handlePrint">打印报表</el-button>
                </div>
                <div class="handle-headright">
                    <el-date-picker v-model="query.daterange" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" class="handle-select mr10" style="width: 300px"></el-date-picker>
                    <el-select v-model="query.deviceName" placeholder="请选择设备" class="handle-select mr10" @change="handleSearch" clearable>
                        <el-option v-for="item in deviceList" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                </div>
            </div>
            
            <div id="print-area">
                <h3 v-if="isPrinting" style="text-align: center; margin-bottom: 20px;">输煤设备状态监测报表</h3>
                <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header">
                    <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
                    <el-table-column prop="deviceName" label="设备名称" width="150" align="center"></el-table-column>
                    <el-table-column prop="status" label="开/停状态" width="100" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.status === '运行中' ? 'success' : 'danger'">{{ scope.row.status }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="time" label="状态切换时刻" width="180" align="center">
                        <template slot-scope="scope">
                            <i class="el-icon-time"></i>
                            {{ scope.row.time }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="runDuration" label="累计运行时间 (h)" width="150" align="center"></el-table-column>
                    <el-table-column prop="hoistCount" label="提升机提升次数" width="150" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.hoistCount > 0 ? scope.row.hoistCount : '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="mineCarCount" label="矿车计数" width="120" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.mineCarCount > 0 ? scope.row.mineCarCount : '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="rubberTiredCarCount" label="胶轮车计数" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.rubberTiredCarCount > 0 ? scope.row.rubberTiredCarCount : '-' }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="pagination" v-show="!isPrinting">
                <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { dateFormat } from '../../utils/helper';

export default {
    name: 'CoalEquipMonitor',
    data() {
        return {
            isPrinting: false,
            deviceList: ['1号主输送机', '2号提升机', '轨道辅助运输车', '主井胶带机'],
            allMockData: [],
            tableData: [],
            pageCount: 0,
            query: {
                daterange: [],
                deviceName: '',
                PageIndex: 1,
                PageSize: 15
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    created() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        this.query.daterange = [start, end];
        
        this.generateMockData();
        this.getData();
    },
    methods: {
        generateMockData() {
            // 生成虚拟数据
            const data = [];
            const now = new Date().getTime();
            for (let i = 0; i < 86; i++) {
                const randomDevice = this.deviceList[Math.floor(Math.random() * this.deviceList.length)];
                const isRunning = Math.random() > 0.3;
                const randomTime = new Date(now - Math.floor(Math.random() * 7 * 24 * 3600 * 1000));
                
                let hoistCount = 0;
                let mineCarCount = 0;
                let rubberCount = 0;
                
                if (randomDevice.includes('提升机')) {
                    hoistCount = Math.floor(Math.random() * 50) + 10;
                } else if (randomDevice.includes('运输')) {
                    mineCarCount = Math.floor(Math.random() * 200) + 50;
                    rubberCount = Math.floor(Math.random() * 80) + 10;
                }
                
                data.push({
                    id: i + 1,
                    deviceName: randomDevice,
                    status: isRunning ? '运行中' : '已停止',
                    time: dateFormat.formatDate(randomTime, 'yyyy-MM-dd hh:mm:ss'),
                    runDuration: (Math.random() * 24).toFixed(1),
                    hoistCount: hoistCount,
                    mineCarCount: mineCarCount,
                    rubberTiredCarCount: rubberCount
                });
            }
            
            // 按时间倒序
            this.allMockData = data.sort((a, b) => new Date(b.time) - new Date(a.time));
        },
        handleSearch() {
            this.query.PageIndex = 1;
            this.getData();
        },
        getData() {
            let filteredData = this.allMockData;
            
            // 设备过滤
            if (this.query.deviceName) {
                filteredData = filteredData.filter(item => item.deviceName === this.query.deviceName);
            }
            
            // 时间过滤
            if (this.query.daterange && this.query.daterange.length === 2) {
                const start = new Date(dateFormat.formatDate(this.query.daterange[0], 'yyyy-MM-dd 00:00:00')).getTime();
                const end = new Date(dateFormat.formatDate(this.query.daterange[1], 'yyyy-MM-dd 23:59:59')).getTime();
                
                filteredData = filteredData.filter(item => {
                    const itemTime = new Date(item.time).getTime();
                    return itemTime >= start && itemTime <= end;
                });
            }
            
            this.pageCount = filteredData.length;
            
            // 分页
            const startIdx = (this.query.PageIndex - 1) * this.query.PageSize;
            const endIdx = startIdx + this.query.PageSize;
            this.tableData = filteredData.slice(startIdx, endIdx);
        },
        handlePageChange(val) {
            this.query.PageIndex = val;
            this.getData();
        },
        handlePrint() {
            this.isPrinting = true;
            this.$nextTick(() => {
                const printContent = document.getElementById('print-area').innerHTML;
                const originalContent = document.body.innerHTML;
                
                document.body.innerHTML = printContent;
                window.print();
                document.body.innerHTML = originalContent;
                
                window.location.reload(); // 刷新页面恢复Vue实例状态
            });
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}
.handle-select {
    width: 200px;
}
.handle-headleft {
    float: left;
    margin-bottom: 15px;
}
.handle-headright {
    float: right;
    margin-bottom: 15px;
}
.table {
    width: 100%;
    font-size: 14px;
}
.mr10 {
    margin-right: 10px;
}
</style>
